import {
  conversationsData,
  CLOSE_CONVERSATIONS_PANEL,
  OPEN_CONVERSATIONS_PANEL,
  SET_CONVERSATION_FILTERS,
} from './types';

export function openConversationsPanel() {
  return { type: OPEN_CONVERSATIONS_PANEL };
}

export function closeConversationsPanel() {
  return { type: CLOSE_CONVERSATIONS_PANEL };
}

export const setConversationsFilters = (prospects, conversationId) => ({
  type: SET_CONVERSATION_FILTERS,
  prospects,
  conversationId,
});

export const requestConversationsData = (entityId, promise) => ({
  type: conversationsData.request,
  entityId,
  promise,
});

export function requestConversationsDataSuccess(response) {
  return {
    type: conversationsData.success,
    response,
  };
}

export function requestConversationsDataFailure(error) {
  return {
    type: conversationsData.failure,
    error,
  };
}
